import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ApplicationController extends Controller {
  @tracked showUpdateModal = false;
  queryParams = ['t'];
  t = null; // access token from admin
}
